import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#eff6ff' },
  card: { background: '#fff', padding: 40, borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', width: '100%', maxWidth: 420 },
  title: { fontSize: 28, fontWeight: 700, color: '#1e3a8a', marginBottom: 8 },
  sub: { color: '#64748b', marginBottom: 28 },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, color: '#374151' },
  input: { width: '100%', padding: '12px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 16, marginBottom: 18, outline: 'none' },
  btn: { width: '100%', padding: '14px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  error: { color: '#ef4444', marginBottom: 16, fontSize: 14 },
  link: { textAlign: 'center', marginTop: 20, color: '#64748b' }
};

export default function Register({ onLogin }) {
  const [form, setForm] = useState({ name: '', email: '', password: '', date_of_birth: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState('');

  const resend = async () => {
    setResendLoading(true);
    setResendMsg('');
    try {
      await api.post('/auth/resend-verification', { email: form.email });
      setResendMsg('Verification email sent! Please check your inbox and spam folder.');
    } catch (err) {
      setResendMsg(err.response?.data?.error || 'Failed to resend. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/register', form);
      setRegistered(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const successStyle = { color: '#16a34a', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '16px', borderRadius: 8, marginBottom: 16, fontSize: 14, lineHeight: 1.6 };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>Create Account</div>
        <div style={s.sub}>Start your free trial — no credit card needed</div>
        {error && <div style={s.error}>{error}</div>}
        {registered ? (
          <>
            <div style={successStyle}>
              <strong>Account created!</strong><br />
              We sent a verification email to <strong>{form.email}</strong>.<br />
              Please check your inbox (and spam folder) and click the link to activate your account.
            </div>
            {resendMsg && (
              <div style={{ ...successStyle, background: resendMsg.includes('Failed') ? '#fef2f2' : '#f0fdf4', border: resendMsg.includes('Failed') ? '1px solid #fecaca' : '1px solid #bbf7d0', color: resendMsg.includes('Failed') ? '#ef4444' : '#16a34a', marginTop: 8 }}>
                {resendMsg}
              </div>
            )}
            <button onClick={resend} disabled={resendLoading} style={{ ...s.btn, background: '#64748b', marginTop: 12 }}>
              {resendLoading ? 'Sending...' : 'Resend Verification Email'}
            </button>
            <div style={s.link}><Link to="/login">Back to Sign In</Link></div>
          </>
        ) : (
          <>
            <form onSubmit={submit}>
              <label style={s.label}>Your Name</label>
              <input style={s.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={12} placeholder="Min 12 characters" />
              <label style={s.label}>Date of Birth <span style={{ color: '#94a3b8', fontWeight: 400 }}>(Must be 18+)</span></label>
              <input style={s.input} type="date" value={form.date_of_birth} onChange={e => setForm({ ...form, date_of_birth: e.target.value })} required />
              <button style={s.btn} disabled={loading}>{loading ? 'Creating...' : 'Create Free Account'}</button>
            </form>
            <div style={s.link}>Already have an account? <Link to="/login">Sign in</Link></div>
            <div style={{ textAlign: 'center', marginTop: 16, paddingTop: 16, borderTop: '1px solid #e2e8f0', fontSize: 12, color: '#94a3b8' }}>
              By creating an account you agree to our{' '}
              <Link to="/terms" style={{ color: '#2563eb' }}>Terms of Service</Link>
              {' '}and{' '}
              <Link to="/privacy" style={{ color: '#2563eb' }}>Privacy Policy</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
